// shabba-dashboard/src/pages/DashboardPage.tsx

import React from 'react';
import SimpleVWAPChart from '../components/SimpleVWAPChart';
import { useMarket } from '../context/MarketContext';
import { OverviewCards } from '../components/OverviewCards';
import { FixLog } from '../components/FixLog';

export default function Dashboard() {
  const {
    selectedSymbol, labelForSecId, currentPrice, lastUpdateTime,
    stats, orderBook, messages, recentTrades
  } = useMarket();

  return (
    <>
      {/* Overview grid */}
      <OverviewCards
        selectedSymbol={selectedSymbol}
        labelForSecId={labelForSecId}
        currentPrice={currentPrice}
        lastUpdateTime={lastUpdateTime}
        stats={stats}
        recentTrades={recentTrades}
        orderBook={orderBook}
      />

      {/* Chart */}
      <div className="chart-container" style={{ background: '#1e293b', padding: 20, borderRadius: 8, border: '1px solid #334155', width: '100%', boxSizing: 'border-box' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>
          {labelForSecId(selectedSymbol)}'s Price Movement with VWAP
        </h3>
        
        {/* Simple Database Charts */} 
        <SimpleVWAPChart symbol={selectedSymbol} height={300} />     
      </div>

      {/* FIX Log */}
      {/* <FixLog messages={messages} labelForSecId={labelForSecId} /> */}
    </>
  );
}
